const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      const elements = document.querySelectorAll('.reveal');

      if (elements.length < 1) {
        return;
      }

      elements.forEach((el) => {
        if (entry.isIntersecting) {
          el.classList.add('opacity-0');
          el.classList.remove('opacity-100');
          setTimeout(() => {
            el.classList.add('hidden');
          }, 300);
        }

        if (!entry.isIntersecting) {
          el.classList.remove('hidden');
          setTimeout(() => {
            el.classList.remove('opacity-0');
            el.classList.add('opacity-100');
          }, 200);
        }
      });
    });
  },
  { threshold: 0 },
);

const handleWindowSizeChange = (e) => {
  const el = document.querySelector('#hero');

  if (!el) {
    return;
  }

  if (e.matches) {
    observer.observe(el);
  } else {
    observer.unobserve(el);
  }
};

const mediaQuery = window.matchMedia('(min-width: 1024px)');
mediaQuery.addListener(handleWindowSizeChange);

handleWindowSizeChange(mediaQuery);
